import ArticleTemplate from "../components/ArticleTemplate";
import { articles } from "@/mocks/articles";

export default function ArticleNajlepszyAgent() {
  return <ArticleTemplate article={articles[8]} />;
}